<template>
  <div class="app">
    <main class="main">
      <router-view />
    </main>
    <LoginRegisterModal />
    <ApiKeyModal />
  </div>
</template>

<script setup lang="ts">
import LoginRegisterModal from '@/components/auth/LoginRegisterModal.vue'
import ApiKeyModal from '@/components/apiKey/ApiKeyModal.vue'
</script>

<style scoped>
.app {
  width: 100%;
  min-height: 100vh;
}

.main {
  min-width: 0;
  width: 100%;
}
</style>
